import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Línea de Tiempo Completa del Agro Argentino',
    desc: 'Visual + explicada + lista para imprimir. 5 versiones: resumida, ampliada, recortable, fechas clave y actores sociales.',
    value: '$8.000'
  }, {
    num: '02',
    title: 'Banco de 120 Actividades Historia Agraria',
    desc: 'Clasificadas por dificultad, nivel, tipo de tarea y tomo. Listas para llevar al aula sin adaptar nada.',
    value: '$10.000'
  }, {
    num: '03',
    title: 'Evaluaciones Editables Completas',
    desc: 'Por tomo, temáticas transversales, recuperatorios, autoevaluaciones, rúbricas y listas de cotejo. Todo listo.',
    value: '$9.000'
  }, {
    num: '04',
    title: 'Guía Rápida para el Docente',
    desc: 'Cómo dar cada tema sin perder tiempo. Conceptos difíciles explicados en palabras simples. Errores frecuentes del alumnado y cómo trabajarlos. Secuencias de 2, 3 y 4 clases por tomo.',
    value: '$8.000'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark border-y border-brand-accent/20" data-id="element-22">
      <div className="max-w-4xl mx-auto" data-id="element-23">
        <div className="text-center mb-8" data-id="element-24">
          <div className="inline-flex items-center justify-center bg-brand-accent text-white font-black px-4 py-1.5 rounded-full mb-3 text-sm md:text-base shadow-md" data-id="element-25">
            <Gift className="w-4 h-4 mr-1.5" data-id="element-26" />4 BONOS ESTRATÉGICOS
          </div>
          <h2 className="text-2xl md:text-4xl font-black text-white" data-id="element-27">
            SIEMPRE INCLUIDOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8" data-id="element-28">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-xl p-5 border border-white/10 hover:border-brand-accent/30 transition-colors relative overflow-hidden group" data-id="element-29">
              <div className="absolute -right-4 -top-4 w-20 h-20 bg-brand-accent/10 rounded-full group-hover:scale-150 transition-transform duration-500" data-id="element-30"></div>

              <div className="flex items-start mb-3 relative z-10" data-id="element-31">
                <div className="bg-brand-accent text-white font-black text-lg w-10 h-10 rounded-lg flex items-center justify-center mr-3 shrink-0" data-id="element-32">
                  {bonus.num}
                </div>
                <div data-id="element-33">
                  <div className="flex items-center gap-1.5 mb-0.5" data-id="element-34">
                    <Gift className="w-3.5 h-3.5 text-brand-accent" data-id="element-35" />
                    <span className="text-brand-accent font-bold text-xs tracking-widest uppercase" data-id="element-36">
                      Bonus {bonus.num}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold leading-tight text-white" data-id="element-37">
                    {bonus.title}
                  </h3>
                </div>
              </div>

              <p className="text-sm text-gray-400 mb-4 relative z-10" data-id="element-38">
                {bonus.desc}
              </p>

              <div className="flex items-center justify-between border-t border-white/10 pt-3 relative z-10" data-id="element-39">
                <span className="text-gray-600 line-through font-medium text-sm" data-id="element-40">
                  {bonus.value}
                </span>
                <span className="text-white font-black text-sm bg-brand-accent px-2 py-0.5 rounded" data-id="element-41">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-xl p-4 text-center border border-brand-accent/20 max-w-xl mx-auto" data-id="element-42">
          <p className="text-lg md:text-xl font-medium text-gray-300" data-id="element-43">
            Valor total bonos:{' '}
            <span className="line-through text-gray-600" data-id="element-44">$35.000</span>{' '}
            <span className="text-brand-accent font-black neon-glow" data-id="element-45">
              → GRATIS
            </span>{' '}
            con tu Kit Completo
          </p>
        </div>
      </div>
    </section>;
}